import { useMutation, useQueryClient } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

type Parameters = {
  companyId: string
  projectId: string
  keywordIds: string[]
}

const handleAddKeywords = async ({
  companyId,
  projectId,
  keywordIds,
}: Parameters): Promise<{
  status: 'error' | 'success'
  message?: string
  error?: string
}> => {
  try {
    const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/keywords/v2`
    const response = await axios.post(url, {
      project_id: projectId,
      suggested_kw_ids: keywordIds,
    })
    return response.data
  } catch (error) {
    return extract.error(error)
  }
}

export const useAddKeywords = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: Parameters) => handleAddKeywords(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['project-keywords'])
      queryClient.invalidateQueries(['keyword-suggestions'])
    },
  })
}
